import { useMemo } from 'react';
import PieChart, { Slice } from '@tcs/common/components/atoms/PieChart';
import InfoCard from '@tcs/common/components/molecules/InfoCard';
import { Investment } from '@tcs/client-portal-api/types/Investment';
import sum from 'lodash/sum';
import { palette, theme } from '@forgeglobal/design-framework';

interface Props {
  title: string;
  cashBalance: Partial<Investment>;
  investmentBalances: Partial<Investment>[];
}

const MAX_DISPLAY_ITEMS = 6;

const AccountHoldingsCard = ({
  title,
  cashBalance,
  investmentBalances,
}: Props) => {
  const slices = useMemo(() => {
    const cashColor = palette.dataVisualizationColors.ForestGreen;
    const assetColors = Object.values(palette.dataVisualizationColors).filter(
      (c) => c !== palette.dataVisualizationColors.ForestGreen
    );

    const allSlices: Slice[] = [
      {
        value: cashBalance.investmentValue,
        label: 'TOTAL CASH BALANCE',
        color: cashColor,
      },
      ...investmentBalances.map((investment, index) => ({
        value: investment.investmentValue,
        label: investment.assetDescription,
        color: assetColors[index % assetColors.length],
      })),
    ];

    allSlices.sort((a, b) => b.value - a.value);

    if (allSlices.length <= MAX_DISPLAY_ITEMS) {
      return allSlices;
    } else {
      return [
        ...allSlices.slice(0, MAX_DISPLAY_ITEMS - 1),
        {
          label: 'OTHER',
          value: sum(
            allSlices
              .slice(MAX_DISPLAY_ITEMS - 1, allSlices.length)
              .map((s) => s.value)
          ),
          color: theme.palette.grey['500'],
        },
      ];
    }
  }, [cashBalance, investmentBalances]);

  return (
    <InfoCard title={title}>
      <PieChart slices={slices} />
    </InfoCard>
  );
};

export default AccountHoldingsCard;
